module.exports = __webpack_public_path__ + "fonts/Roboto-300-cyrillic23.f92ee38.woff2";